import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ModuleConfiguration } from 'src/app/app.module';
import { ReportModulesService } from 'src/app/services/report-modules/report-modules.service';
import {
  toApiImageUrl,
  toExternalImageUrl,
} from 'src/app/tools/image-url';
import { UserService } from 'src/app/user.service';
import { environment } from 'src/environments/environment';
import { ImageViewerConfigComponent } from '../config/image-viewer-config/image-viewer-config.component';
import { ImageViewerConfig } from '../image-viewer.tools';

@Component({
    selector: 'app-image-viewer',
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.scss'],
    standalone: false
})
export class ImageViewerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() config: ImageViewerConfig;
  @ViewChild('image') image: ElementRef;

  public static moduleDetails: ModuleConfiguration = {
    displayName: 'Bild / Webcam',
    previewImagePath: 'assets/image_viewer_preview.png',
    settingsComponent: ImageViewerConfigComponent,
  };

  public lastUpdate = new Date(Date.now());
  private updateInterval: ReturnType<typeof setInterval> | null = null;
  public imageURL: string | null = null;

  constructor(
    public reportModuleService: ReportModulesService,
    public userService: UserService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const configuredUrl = this.config.refresh
      ? toExternalImageUrl(this.config.resource_url)
      : toApiImageUrl(environment.apiEndpoint, this.config.resource_url);
    this.updateImage(configuredUrl);

    if (this.config.refresh === true && configuredUrl !== null) {
      this.updateInterval = setInterval(() => {
        this.lastUpdate = new Date(Date.now());
        this.updateImage(configuredUrl);
      }, this.config.refresh_timer * 1000);
    }
  }

  ngOnDestroy(): void {
    if (this.updateInterval !== null) {
      clearInterval(this.updateInterval);
      this.updateInterval = null;
    }
  }

  private updateImage(value: string | null): void {
    this.imageURL = value;
    this.image.nativeElement.src = value ?? '';
  }
}
